export default "__VITE_ASSET__jw_wor3Q__"